import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/comics';

export default function HeroSection() {
  const featuredManga = mangaList.filter((m) => m.featured).slice(0, 3);

  return (
    <section
      className="relative w-full min-h-[620px] flex items-center"
      aria-labelledby="hero-heading"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20Korean%20manhwa%20webtoon%20art%20collage%20with%20vibrant%20comic%20panels%20featuring%20various%20characters%20in%20dynamic%20poses%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20dramatic%20speed%20lines%2C%20action%20scenes%20and%20romantic%20moments%20blended%20together%2C%20modern%20webtoon%20aesthetic%2C%20atmospheric%20lighting%2C%20cinematic%20composition&width=1600&height=900&seq=hero-bg-kr-manga&orientation=landscape"
          alt="韩国漫画网 - 韩漫在线阅读"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <h1
            id="hero-heading"
            className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight"
          >
            韩国漫画网
            <span className="block text-xl md:text-2xl lg:text-3xl font-medium mt-3 text-background-200">
              韩漫在线阅读 — 无删减下拉式韩漫大全
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-background-300 max-w-xl leading-relaxed">
            我们提供无删减下拉式韩漫大全供您<strong>免费在线阅读</strong>，确保作品内容的完整性与原汁原味，为您保留最真实的故事情节。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即开始阅读
              <span className="w-4 h-4 inline-flex items-center justify-center ml-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/category/rexue"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/20 font-medium rounded-full text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-8 mt-16 w-full max-w-lg">
            {[
              { value: '5,000+', label: '韩漫作品' },
              { value: '120,000+', label: '漫画章节' },
              { value: '2.5亿+', label: '累计阅读' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col items-center">
                <span className="font-heading font-bold text-2xl md:text-3xl text-primary-400">
                  {stat.value}
                </span>
                <span className="text-xs text-background-300 mt-1 whitespace-nowrap">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}